<div class="malfunction-filter__section">
  <div class="malfunction-filter__title">{{ "Malfunction.FilterOnPeriod" | translate }}</div>
  <div class="malfunction-filter__split">
    <div class="malfunction-filter__select-wrapper">
      <input
        class="malfunction-filter__input"
        type="text"
        id="startDate"
        mwlFlatpickr
        [dateFormat]="'d-m-Y'"
        [convertModelValue]="true"
        [disableMobile]="true"
        [(ngModel)]="startDate"
      />
      <svg-icon class="malfunction-filter__select-calendar-icon" src="assets/images/icons/select-calendar.svg">
      </svg-icon>
    </div>
    <div class="malfunction-filter__select-wrapper">
      <input
        class="malfunction-filter__input"
        type="text"
        id="endDate"
        mwlFlatpickr
        [dateFormat]="'d-m-Y'"
        [convertModelValue]="true"
        [disableMobile]="true"
        [(ngModel)]="endDate"
      />
      <svg-icon class="malfunction-filter__select-calendar-icon" src="assets/images/icons/select-calendar.svg">
      </svg-icon>
    </div>
  </div>
</div>
